import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const HdiCarbon1836Lvs32 = () => {
  console.log('🎯 HdiCarbon1836Lvs32 component loading');
  
  const product = findProductById("hdi-carbon-18-36-lvs32");
  
  if (!product) {
    console.error('Product not found:', "hdi-carbon-18-36-lvs32");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="hdi-carbon-18-36-lvs32"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default HdiCarbon1836Lvs32; 